import styled from '@emotion/styled';
import { Typography, TypographyProps } from '@mui/material';

const StyledHeading = styled(Typography)({
    fontSize: '1.75rem',
    fontWeight: 'bold',
    color: '#333'
});

export const PageHeading = (props: TypographyProps) => {
    return <StyledHeading variant="h2" {...props} />;
};
